import * as React from 'react'
import {FC, memo, useState} from 'react'
import Form from 'antd/lib/form'
import 'antd/lib/form/style'
import Row from 'antd/lib/row'
import 'antd/lib/row/style'
import Col from 'antd/lib/col'
import 'antd/lib/col/style'
import Select from 'antd/lib/select'
import 'antd/lib/select/style'
import IDS from '../../constants/ids'
import CalcCard from '../../../../common/components/calc-card'
import {COMPONENT_SIZE} from '../../constants'
import LABELS from '../../constants/labels'
import TOOLTIPS from '../../constants/tooltips'
import {ProgramInfo} from '../../types/models/program-info'
import {
    STANDARD_ITEM_RULES_SELECT,
    STANDARD_ITEM_RULES_SELECT_MULTIPLE,
} from '../../../../common/constants'
import Radio from 'antd/lib/radio'
import 'antd/lib/radio/style'
import Tooltip from 'antd/lib/tooltip'
import 'antd/lib/tooltip/style'
import QuestionCircleOutlined from '@ant-design/icons/lib/icons/QuestionCircleOutlined'
import {FormInstance} from 'antd/lib/form'
import {Checkbox} from "antd";

const {Item} = Form,
    {Option} = Select,
    {Group} = Radio

interface TransportInfoPropsInterface {
    onValueChange: (fieldName: string | string[]) => void
    programInfo: ProgramInfo
    form: FormInstance
}

const TransportInfo: FC<TransportInfoPropsInterface> = memo(
    ({onValueChange, programInfo, form}) => {
        const [transportTypes, setTransportTypes] = useState([]),
            handleLongDeliveryChange = event => {
                form.setFieldsValue({[IDS.TRANSPORT_SHIPPING]: null})
                if (
                    form.getFieldValue(IDS.TRANSPORT_TYPE) &&
                    form.getFieldValue(IDS.TRANSPORT_TYPE).includes('car') &&
                    form.getFieldValue(IDS.TRANSPORT_TYPE).length <= 1
                ) {
                    return
                    // ничего не происходит
                } else if (event.target.value) {
                    setTransportTypes([...transportTypes, 'car'])
                } else {
                    setTransportTypes(
                        transportTypes.filter(transportType => transportType !== 'car')
                    )
                }

                onValueChange(IDS.TRANSPORT_LONG_DELIVERY)
            },
            filterShippingTypes = (shippingType, index) => {
                if (transportTypes) {
                    switch (shippingType.transport) {
                        case 'ship':
                            if (
                                transportTypes.includes('1ss') ||
                                transportTypes.includes('2SS') ||
                                transportTypes.includes('3SS')
                            )
                                return true
                            else break

                        case 'car':
                            if (transportTypes.includes('car')) return true
                            else break

                        case 'train':
                            if (transportTypes.includes('train')) return true
                            else break
                        case 'plane':
                            if (transportTypes.includes('plane')) return true
                            else break
                        default:
                            return false
                    }
                } else {
                    return false
                }
            },
            filterMistakes = (shippingType, index) => {
                if (shippingType.code === 'closeDeck') {
                    return false
                } else {
                    return true
                }
            },
            duplicatesReducer = (newArray, shippingType) => {
                if (!newArray.some(el => el.code === shippingType.code)) {
                    newArray.push(shippingType)
                }
                return newArray
            }

        return (
            <CalcCard>
                <h2>Особенности перевозки</h2>
                <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <Item
                            name={IDS.TRANSPORT_TYPE}
                            label={LABELS.TRANSPORT_TYPE}
                            rules={STANDARD_ITEM_RULES_SELECT_MULTIPLE}
                            required
                        >
                            <Select
                                mode={'multiple'}
                                className='e-full-wide'
                                placeholder='Укажите виды транспорта'
                                size={COMPONENT_SIZE}
                                onChange={(val: string[]) => {
                                    form.setFieldsValue({[IDS.TRANSPORT_SHIPPING]: null})
                                    form.setFieldsValue({[IDS.TRANSPORT_LONG_DELIVERY]: null})
                                    setTransportTypes(val)
                                    onValueChange(IDS.TRANSPORT_TYPE)
                                }}
                            >
                                {programInfo.transport.map((transportType, index) => (
                                    <Option
                                        value={transportType.code}
                                        key={`transport-${index}-${transportType.code}`}
                                    >
                                        {transportType.name}
                                    </Option>
                                ))}
                            </Select>
                        </Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Item name='onTheRoad' valuePropName={'checked'}>
                            <Checkbox>Груз в пути</Checkbox>
                        </Item>
                    </Col>
                </Row>
                <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                    <Col xs={24} sm={24} md={24}>
                        <Item
                            name={IDS.TRANSPORT_LONG_DELIVERY}
                            label={
                                <span>
                                    {LABELS.TRANSPORT_LONG_DELIVERY}{' '}
                                    <Tooltip title={TOOLTIPS.TRANSPORT_LONG_DELIVERY}>
                                        <QuestionCircleOutlined
                                            style={{color: 'rgba(0,0,0,.45)'}}
                                        />
                                    </Tooltip>
                                </span>
                            }
                            rules={STANDARD_ITEM_RULES_SELECT}
                        >
                            <Group className='e-full-wide' onChange={handleLongDeliveryChange}>
                                <Radio value={false} key={`short`}>
                                    {'200 км и менее'}
                                </Radio>
                                <Radio value={true} key={`long`}>
                                    {'превышает 200 км'}
                                </Radio>
                            </Group>
                        </Item>
                    </Col>
                </Row>
                <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                        <Item
                            name={IDS.TRANSPORT_GUARD}
                            label={LABELS.TRANSPORT_GUARD}
                            rules={STANDARD_ITEM_RULES_SELECT}
                            required
                        >
                            <Select
                                className='e-full-wide'
                                placeholder='Укажите тип охраны'
                                size={COMPONENT_SIZE}
                                onChange={() => {
                                    onValueChange(IDS.TRANSPORT_GUARD)
                                }}
                            >
                                {programInfo.guard.map((guardType, index) => (
                                    <Option
                                        value={guardType.code}
                                        key={`guard-${index}-${guardType.code}`}
                                    >
                                        {guardType.name}
                                    </Option>
                                ))}
                            </Select>
                        </Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                        <Item
                            name={IDS.TRANSPORT_SHIPPING}
                            label={LABELS.TRANSPORT_SHIPPING}
                            rules={STANDARD_ITEM_RULES_SELECT}
                            required
                        >
                            <Select
                                className='e-full-wide'
                                placeholder='Укажите способ перевозки груза'
                                size={COMPONENT_SIZE}
                                notFoundContent={<p>Сперва укажите виды транспорта</p>}
                                onChange={() => {
                                    onValueChange(IDS.TRANSPORT_SHIPPING)
                                }}
                            >
                                {programInfo.shipping
                                    .filter(filterShippingTypes)
                                    .filter(filterMistakes)
                                    .reduce(duplicatesReducer, [])
                                    .map((shippingType, index) => (
                                        <Option
                                            value={shippingType.code}
                                            key={`shipping-${index}-${shippingType.code}`}
                                        >
                                            {shippingType.name}
                                        </Option>
                                    ))}
                            </Select>
                        </Item>
                    </Col>
                </Row>
            </CalcCard>
        )
    }
)

export default TransportInfo
